<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<h2 mat-dialog-title>
  DSE
  <img class="close-button" (click)="onNoClick()" src="/assets/images/close.png" alt="">
</h2>
<mat-dialog-content>
  <form [formGroup]="salesManagerForm" >
    <div class="row mb-3">
      <div class="col-md-6">
        <label for="product_category" class="form-label">Product Category <span class="alert-small">*</span></label>
        <select class="form-select" formControlName="product_category" (change)="onCategoryChange($event)"
        [attr.value]="salesManagerForm.get('product_category')?.value"
        [ngClass]="{ 'is-invalid': submitted && f['product_category'].errors }">
          <option disabled selected value="">Select</option>
          <ng-container *ngFor="let category of categories">
            <option [value]="category.id  + ':' + category.product_categories">{{ category.product_categories }}</option>
          </ng-container>
        </select>
        <div *ngIf="submitted && f['product_category'].errors" class="invalid-feedback">
          <div *ngIf="salesManagerForm.get('product_category')?.errors?.['required']" class="error-msg">
            Please Select Product Category.
          </div>
        </div>
    </div>
    <div class="col-md-6">
      <label class="form-label">Product Model<span class="alert-small">*</span></label>
      <select class="form-select" formControlName="product_model" (change)="onModelChange($event)" 
      [attr.value]="salesManagerForm.get('product_model')?.value"
      [ngClass]="{ 'is-invalid': submitted && f['product_model'].errors }">
        <option disabled selected value="">Select</option>
        <option *ngFor="let product of filteredProducts" id="{{product.id}}" [value]="product.id + ':' + product.model">{{ product.model }}</option>
        </select>
        <div *ngIf="submitted && f['product_model'].errors" class="invalid-feedback">
          <div *ngIf="salesManagerForm.get('product_model')?.errors?.['required']" class="error-msg">
            Please Select Product Model.
          </div>
        </div>
    </div>    
    </div>
    <div class="row mb-3">
      <div class="col-md-6">
          <label class="form-label">Assign To<span class="alert-small">*</span></label>
          <select class="form-select" formControlName="assign_to"  [attr.value]="salesManagerForm.get('assign_to')?.value"
          [ngClass]="{ 'is-invalid': submitted && f['assign_to'].errors }">
          <option disabled selected value="">Select</option>
          <option *ngFor="let salesmanager of filteredSalesmanagers" [value]="salesmanager.user_id">{{ salesmanager.first_name }}</option>
        </select>
           <div *ngIf="submitted && f['assign_to'].errors" class="invalid-feedback">
            <div *ngIf="salesManagerForm.get('assign_to')?.errors?.['required']" class="error-msg">
                Please Select Assign to.
            </div>
        </div>
      
      </div>
      <div class="col-md-6 mb-3">
        <label class="form-label">Variant <span class="alert-small">*</span></label>
        <select class="form-select" formControlName="product_variant" 
        [attr.value]="salesManagerForm.get('product_variant')?.value" (change)="onVariantChange()"
        [ngClass]="{ 'is-invalid': submitted && f['product_variant'].errors }">
          <option value="" selected disabled>Select</option>
          <option *ngFor="let variant of filteredVariants" [value]="variant.id +':'+ variant.variant">{{ variant.variant }}</option>
        </select>
        <div *ngIf="submitted && f['product_variant'].errors" class="invalid-feedback">
          <div *ngIf="salesManagerForm.get('product_variant')?.errors?.['required']" class="error-msg">
            Please Select Product Variant.
          </div>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <label for="product_color" class="form-label">Color <span class="alert-small">*</span></label>
        <select id="product_color" class="form-select" formControlName="product_color" 
        [attr.value]="salesManagerForm.get('product_color')?.value"
        [ngClass]="{ 'is-invalid': submitted && f['product_color'].errors }">
          <option value="" selected disabled>Select</option>
          <option *ngFor="let color of filteredColor" [value]="color.id +':'+ color.color">{{ color.color }}</option>
        </select>
        <div *ngIf="submitted && f['product_color'].errors" class="invalid-feedback">
          <div *ngIf="salesManagerForm.get('product_color')?.errors?.['required']" class="error-msg">
            Please Select Product Color.
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label for="interest_level" class="form-label">Interest Level</label>
        <select id="interest_level" class="form-select" formControlName="interest_level" (change)="onInterestChange($event)"
        [attr.value]="salesManagerForm.get('interest_level')?.value">
          <option value="" selected disabled>Select</option>
          <option *ngFor="let interest of interestLevel" [value]="interest.id +':'+ interest.interest_level">{{ interest.interest_level }}</option>
        </select>
      </div>
    </div>

    <div class="row mb-3">

      <div class="col-md-6">
        <label for="customer_requirement" class="form-label">Customer Requirement</label>
        <select id="customer_requirement" class="form-select" formControlName="customer_requirement" [attr.value]="salesManagerForm.get('customer_requirement')?.value">
          <option value="" selected disabled>Select</option>
          <option *ngFor="let requirement of filteredRequirements" [value]="requirement.id +':'+ requirement.requirement">{{ requirement.requirement }}</option>
        </select>
      </div>
      
      <div class="col-md-6">
        <label for="age_group" class="form-label">Age Group <span class="alert-small">*</span></label>
        <select id="age_group" class="form-select" formControlName="age_group" [attr.value]="salesManagerForm.get('age_group')?.value"
        [ngClass]="{ 'is-invalid': submitted && f['age_group'].errors }">
          <option value="" selected disabled>Select</option>
          <option *ngFor="let age of ageGroupList" [value]="age.id +':'+ age.age_group">{{ age.age_group }}</option>
        </select>
        <div *ngIf="submitted && f['age_group'].errors" class="invalid-feedback">
          <div *ngIf="salesManagerForm.get('age_group')?.errors?.['required']" class="error-msg">
            Please Select Age Group.
          </div>
        </div>
      </div>
    </div>

    <!-- followup added -->
    <!-- <div class="row mb-3">
      <div class="col-md-6">
        <label for="follow-up" class="form-label">Follow-up Date</label>
        <div class="input-group">
          <input readonly class="form-control" style="cursor: pointer;" #inputField [attr.value]="salesManagerForm.get('followup_date')?.value"
							formControlName="followup_date">
          <div class="input-group-append">
            <span class="input-group-text" style="cursor: pointer;">
              <i class="fa fa-calendar" aria-hidden="true"></i>
            </span>
          </div>
        </div>
      </div>
      
      <div class="col-md-6">
        <label for="followuptime" class="form-label">Follow-up Time <span class="alert-small">*</span></label>
        <div class="input-group">
          <input type="text" 
              readonly 
              class="form-control"
              formControlName="followup_time"
              [matTimepicker]="timepicker" 
              (click)="timepicker.open()" 
              placeholder="Select Time"
              #inputField />
          <div class="input-group-append">
            <span class="input-group-text" (click)="timepicker.open()" style="cursor: pointer;">
              <i class="fa fa-clock" aria-hidden="true"></i>
            </span>
          </div>
        </div>
        <mat-timepicker #timepicker touchUi mode="input"></mat-timepicker>
        <div *ngIf="submitted && f['followup_time'].errors" class="is-invalid">
          <div *ngIf="salesManagerForm.get('followup_time')?.errors?.['required']" class="error-msg">
            Please enter followup time.
          </div>
        </div>
          

        <div *ngIf="salesManagerForm.get('followup_time')?.errors?.['futureTime']" class="error-msg">
          Selected time cannot be greater than current time.
        </div>
        
				
      </div>
    </div> -->

    <div class="row mb-3">
      <div class="col-md-6">
        <label for="follow-up" class="form-label">Follow-up Date <span class="alert-small">*</span></label>
        <div class="input-group">
          <input readonly class="form-control" style="cursor: pointer;" #inputField (click)="picker.open()" [attr.value]="salesManagerForm.get('followup_date')?.value" [matDatepicker]="picker" 
							formControlName="followup_date" placeholder="Select Date" [min]="minDate">
          <div class="input-group-append">
            <span class="input-group-text" style="cursor: pointer;">
              <i class="fa fa-calendar" aria-hidden="true"></i>
            </span>
          </div>
        </div>
        <mat-datepicker #picker></mat-datepicker>
        <!-- <div style="margin-top: -20px" *ngIf="submitted  && f['followup_date'].errors"> -->
        <div *ngIf="submitted && f['followup_date'].errors" class="is-invalid">
						<div *ngIf="salesManagerForm.get('followup_date')?.errors?.['required']" class="error-msg">
							Please Select Follow-up Date.
						</div>
					</div>
      </div>
      
      <div class="col-md-6">
        <label for="followuptime" class="form-label">Follow-up Time <span class="alert-small">*</span></label>
        <div class="input-group">
          <input type="text" 
              readonly 
              class="form-control"
              formControlName="followup_time"
              [matTimepicker]="timepicker" 
              (click)="timepicker.open()" 
              placeholder="Select Time"
              #inputField />
          <div class="input-group-append">
            <span class="input-group-text" (click)="timepicker.open()" style="cursor: pointer;">
              <i class="fa fa-clock" aria-hidden="true"></i>
            </span>
          </div>
        </div>
        <mat-timepicker #timepicker touchUi mode="input"></mat-timepicker>
        <div *ngIf="submitted && f['followup_time'].errors" class="is-invalid">
          <div *ngIf="salesManagerForm.get('followup_time')?.errors?.['required']" class="error-msg">
            Please enter followup time.
          </div>
        </div>
          

        <div *ngIf="salesManagerForm.get('followup_time')?.errors?.['futureTime']" class="error-msg">
          Selected time cannot be greater than current time.
        </div>
        
				
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <label for="action" class="form-label">Action <span class="alert-small">*</span></label>
        <div class="input-group">
          <select id="action" class="form-select" formControlName="action" 
          [attr.value]="salesManagerForm.get('action')?.value"
          [ngClass]="{ 'is-invalid': submitted && f['action'].errors }">
          <option value="" selected disabled >Select</option>
          <option *ngFor="let data of actionList" [value]="data.id + ':' + data.mode_of_contact">{{
							data.mode_of_contact }}</option>
        </select>
          <div *ngIf="submitted && f['action'].errors" class="invalid-feedback">
              <div *ngIf="salesManagerForm.get('action')?.errors?.['required']" class="error-msg">
                Please Select action.
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-6">
        <label for="followup" class="form-label">Follow-up <span class="alert-small">*</span></label>
        	<select id="followup" class="form-select" formControlName="followup" [attr.value]="salesManagerForm.get('followup')?.value"
        [ngClass]="{ 'is-invalid': submitted && f['followup'].errors }">
          <option value="" selected disabled>Select</option>
          <option *ngFor="let data of followupList" [value]="data.id + ':' + data.reason">{{
							data.reason }}</option>
        </select>
        <div *ngIf="submitted && f['followup'].errors" class="invalid-feedback">
            <div *ngIf="salesManagerForm.get('followup')?.errors?.['required']" class="error-msg">
              Please Select followup.
          </div>
        </div>
				
      </div>
    </div>

    <div class="mb-3">
      <label for="remarks" class="form-label">Remarks</label>
      <textarea class="form-control" id="remarks" [attr.value]="salesManagerForm.get('remarks')?.value" formControlName="remarks" rows="3" placeholder="Enter Text here"></textarea>
    </div>


  </form>
</mat-dialog-content>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button class="btn white-btn mr-2" type="button" (click)="onNoClick()">Cancel</button>
  <!-- <button class="btn blue-btn mr-3" type="submit" (click)="onSubmit()">Submit</button> -->
  <button class="btn blue-btn mr-3" type="submit"  (click)="onSubmit()">Submit</button>
</div>